/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-vars */
/* eslint-disable max-len */
import React, { useState } from 'react';

function GST({
    formulaUpdated, setFormulaUpdated, params, fetchedFormula, setChangesMade,
}) {
    const [gstparams, setgstParams] = useState(fetchedFormula[params]);

    const InputChange = (e, index) => {
        setChangesMade(true);
        e.preventDefault();
        const { id, value } = e.target;
        if (value.trim() === '' || parseFloat(value) >= 100 || parseFloat(value) <= 0) {
            gstparams[id] = '';
            setgstParams((prevState) => ({
                ...prevState,
                [id]: '',
            }));
        } else {
            gstparams[id] = value;
            setgstParams((prevState) => ({
                ...prevState,
                [id]: value,
            }));
        }
        formulaUpdated[params] = gstparams;
        setFormulaUpdated(formulaUpdated);
    };
    return (
        <div className="rounded-[10px] bg-[#FFFFFF] py-[22px] px-5 shadow-s16 mb-4">
            <p className="text-f3 font-normal text-[#090406] pb-5">GST (%)</p>
            <div className="flex items-center -mx-0.5">
                <div className="px-0.5 w-[27%]">
                    <div className="relative w-full">
                        <input
                            type="number"
                            id="consumables"
                            className="h-12 w-full rounded-lg outline-0 border border-[#B1B4B7] bg-[#FFFFFF] text-sm58 font-normal text-[#808285] px-3 err-Border"
                            autoComplete="off"
                            onKeyDown={(e) => {
                                if (e.which === 38 || e.which === 40) {
                                    e.preventDefault();
                                }
                            }}
                            onChange={(e) => {
                                InputChange(e);
                            }}
                            onWheel={(e) => e.target.blur()}
                            value={gstparams.consumables}

                        />
                        <label htmlFor="consumables" className="text-sm42 font-normal text-[#808285] absolute -top-2 left-3 px-1 bg-[#FFFFFF]">
                            Consumables
                            {' '}
                            <span className="text-[#ED1C24]">*</span>
                        </label>
                    </div>
                </div>
                <div className="px-0.5 w-[27%]">
                    <div className="relative w-full">
                        <input
                            type="number"
                            id="equipment"
                            className="h-12 w-full rounded-lg outline-0 border border-[#B1B4B7] bg-[#FFFFFF] text-sm58 font-normal text-[#808285] px-3 err-Border"
                            autoComplete="off"
                            onKeyDown={(e) => {
                                if (e.which === 38 || e.which === 40) {
                                    e.preventDefault();
                                }
                            }}
                            onChange={(e) => {
                                InputChange(e);
                            }}
                            onWheel={(e) => e.target.blur()}
                            value={gstparams.equipment}

                        />
                        <label htmlFor="equipment" className="text-sm42 font-normal text-[#808285] absolute -top-2 left-3 px-1 bg-[#FFFFFF]">
                            Equipments
                            {' '}
                            <span className="text-[#ED1C24]">*</span>
                        </label>
                    </div>
                </div>
                <div className="px-0.5 w-[27%]">
                    <div className="relative w-full">
                        <input
                            type="number"
                            id="mnr"
                            className="h-12 w-full rounded-lg outline-0 border border-[#B1B4B7] bg-[#FFFFFF] text-sm58 font-normal text-[#808285] px-3 err-Border"
                            autoComplete="off"
                            onKeyDown={(e) => {
                                if (e.which === 38 || e.which === 40) {
                                    e.preventDefault();
                                }
                            }}
                            onChange={(e) => {
                                InputChange(e);
                            }}
                            onWheel={(e) => e.target.blur()}
                            value={gstparams.mnr}

                        />
                        <label htmlFor="equipment" className="text-sm42 font-normal text-[#808285] absolute -top-2 left-3 px-1 bg-[#FFFFFF]">
                            MnR
                            {' '}
                            <span className="text-[#ED1C24]">*</span>
                        </label>
                    </div>
                </div>
                <div className="px-0.5 w-[27%]">
                    <div className="relative w-full">
                        <input
                            type="number"
                            id="others"
                            className="h-12 w-full rounded-lg outline-0 border border-[#B1B4B7] bg-[#FFFFFF] text-sm58 font-normal text-[#808285] px-3 err-Border"
                            autoComplete="off"
                            onKeyDown={(e) => {
                                if (e.which === 38 || e.which === 40) {
                                    e.preventDefault();
                                }
                            }}
                            onChange={(e) => {
                                InputChange(e);
                            }}
                            onWheel={(e) => e.target.blur()}
                            value={gstparams.others}

                        />
                        <label htmlFor="others" className="text-sm42 font-normal text-[#808285] absolute -top-2 left-3 px-1 bg-[#FFFFFF]">
                            Others
                            {' '}
                            <span className="text-[#ED1C24]">*</span>
                        </label>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default GST;
